export const LOGIN_API = '/api/admin/auth/login'
export const PROFILE_API = '/api/admin/profile'
export const PERMISSION_API = '/api/admin/profile/permissions'
export const TOKEN_REFRESH_API = '/api/admin/auth/token/refresh'

export const SYSTEM_MAIN_SYSTEM_API = '/api/admin/main-systems'
export const SYSTEM_SUB_SYSTEM_API = '/api/admin/sub-systems'
export const DEPARTMENTS_API = '/api/admin/departments'
export const POSITIONS_API = '/api/admin/positions'
export const PERMISSION_GROUPS_API = '/api/admin/permission-groups'
export const COMPANIES_API = '/api/admin/companies'
export const EMPLOYEES_API = '/api/admin/employees'
export const FIRM_COLLABORATES_API = '/api/admin/collaborates'
export const FIRM_COLLABORATES_ACTIVITIES_API =
  '/api/admin/collaborate-activities'
export const FIRM_COLLABORATE_ORDERS_API = '/api/admin/collaborate-firm-orders'
export const FIRM_EXPORT_FIELDS_API = '/api/admin/collaborate-activities/fields'

export const HOME_API = '/api/admin/home'
export const HOME_CONFIG_API = '/api/admin/home/config'
export const HOME_CAROUSELS_API = '/api/admin/home/carousels'
export const HOME_SHARE_VIDEOS_API = '/api/admin/home/share-videos'
export const HOME_HEADER_API = '/api/admin/home/header'
export const HOME_FOOTER_API = '/api/admin/home/footer'
export const HOME_RECENTLY_HOT_API = '/api/admin/home/recently-hot'

export const PRODUCTS_API = '/api/admin/products'
export const PRODUCTS_BATCH_API = '/api/admin/products/batch'

export const AREA_API = '/api/admin/areas'
export const TRAVEL_AREA_API = '/api/admin/travel-areas'
export const TRAVEL_REGION_API = '/api/admin/travel-regions'
export const TRAVEL_ZONE_API = '/api/admin/travel-zones'
export const CATALOG_API = '/api/admin/catalogs'
export const CONTINENT_API = '/api/admin/continent'
export const COUNTRY_TEMPLATES_API = '/api/admin/country-templates'
export const COUNTRIES_API = '/api/admin/countries'
export const REGIONS_API = '/api/admin/regions'
export const CITY_TEMPLATES_API = '/api/admin/city-templates'
export const CITIES_API = '/api/admin/cities'
export const TRAVELER_TYPES_API = '/api/admin/traveler-types'
export const AIRLINE_API = '/api/admin/airlines'
export const HOTELS_API = '/api/admin/hotels'
export const LEADERS_API = '/api/admin/leaders'
export const TOP_TRAVEL_API = '/api/admin/top-travels'
export const FLY_SCHEDULE_API = '/api/admin/fly-schedules'
export const WEATHER_API = '/api/admin/weathers'
export const BLOG_SHARES_API = '/api/admin/blog-shares'
export const SATISFACTIONS_API = '/api/admin/satisfactions'
export const LECTURES_API = '/api/admin/lectures'
export const TOURISM_NEWS_API = '/api/admin/tourism-news'
export const NEWS_API = '/api/admin/news'
export const BLOG_API = '/api/admin/blog'
export const OFFERS_API = '/api/admin/offers'
export const EDM_API = '/api/admin/edm'
export const SUBSCRIPTIONS_API = '/api/admin/subscriptions'
export const TOUR_LEADERS_API = '/api/admin/tour-leaders'
export const MAGAZINES_API = '/api/admin/magazines'
export const GIFTS_API = '/api/admin/gifts'
export const GIFT_POSTS_API = '/api/admin/gift-posts'
export const GIFT_PURCHASES_API = '/api/admin/gift-purchases'
export const GIFT_TRANSFERS_API = '/api/admin/gift-transfers'
export const GIFT_REVIEWS_API = '/api/admin/gift-reviews'
export const GIFT_RETURNS_API = '/api/admin/gift-returns'

export const TRAVEL_GROUPS_API = '/api/admin/travel-groups'
export const TRAVEL_GROUPS_BATCH_API = '/api/admin/travel-groups/batch'

export const ORDERS_API = '/api/admin/orders'
export const INQUIRIES_API = '/api/admin/inquiries'
export const LECTURE_ORDERS_API = '/api/admin/lecture-orders'
export const Tour_Demands_API = '/api/admin/tour-demands'

export const COLLABORATE_ORDERS_API = '/api/admin/collaborate-orders'
export const USER_ORDER_DETAILS_API = '/api/admin/user-orders/details'

export const LOGS_API = '/api/admin/logs'

export const PAGE_SEO_API = '/api/admin/pages-seo'
export const HONEY_MOON_API = '/api/admin/honey-moons'

export const ANALYTICS_API = '/api/admin/analytics'

export const MEMBER_API = '/api/admin/member'

export const ATTRIBUTES_API = '/api/admin/attributes'

export const USER_API = '/api/admin/users'

export const MEETING_API = '/api/admin/meetings'

export const MEETING_ROOMS_API = '/api/admin/meeting-rooms'
export const Demands_API = '/api/admin/demand'

export const LINE_API = '/api/admin/line'

export const COMPLAINTS_API = '/api/admin/complaints'

export const PUBLICATION_DEMANDS_API = '/api/admin/publication-demands'

export const TRAVEL_GROUP_BY_COWELL = '/api/admin/travel-group-by-cowell'

export const BUSINESS_ENTITY_API = '/api/admin/business-entity'
